import { render, staticRenderFns } from "./Formularios.vue?vue&type=template&id=47639ce3&scoped=true"
import script from "./Formularios.vue?vue&type=script&lang=js"
export * from "./Formularios.vue?vue&type=script&lang=js"
import style0 from "./Formularios.vue?vue&type=style&index=0&id=47639ce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47639ce3",
  null
  
)

export default component.exports